(function () {
  const THRESHOLD_CENTS = 1500; // show when within $15 of $100
  const GOAL_CENTS = 10000; // $100
  const CHECK_INTERVAL_MS = 2000; // poll every 2 seconds

  let dismissedAtTotal = null; // cart total (cents) at the moment it was last dismissed

  async function getCartTotal() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart.total_price;
  }

  function inRange(totalCents) {
    const remaining = GOAL_CENTS - totalCents;
    return remaining > 0 && remaining <= THRESHOLD_CENTS;
  }

  function showModal() {
    const modal = document.getElementById('cart-upsell-modal');
    if (modal) modal.hidden = false;
  }

  function hideModal() {
    const modal = document.getElementById('cart-upsell-modal');
    if (modal) modal.hidden = true;
  }

  async function checkThreshold() {
    try {
      const total = await getCartTotal();

      if (!inRange(total)) {
        hideModal();
        dismissedAtTotal = null; // reset once out of range
        return;
      }

      // In range: only show if not already dismissed at this exact total
      if (total !== dismissedAtTotal) {
        showModal();
      }
    } catch (err) {
      console.error('cart-upsell: failed to fetch cart', err);
    }
  }

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-upsell-close]')) {
      const total = await getCartTotal();
      dismissedAtTotal = total; // remember the total we dismissed at
      hideModal();
      return;
    }

    const addBtn = e.target.closest('[data-upsell-add]');
    if (addBtn) {
      const variantId = addBtn.dataset.variantId;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        }),
      });

      const state = await response.json();
      window.FoxThemeEvents.emit('ON_ITEM_ADDED', state);
      hideModal();
      // dismissedAtTotal stays as-is here — the cart total will have
      // changed on the next check, so it naturally becomes eligible again
      // only if it re-enters the $15 range at a NEW total
    }
  });

  checkThreshold();
  setInterval(checkThreshold, CHECK_INTERVAL_MS);
})();